import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';
import { translate } from 'react-i18next';
import Table from 'antd/lib/table';
import { t } from '../../../app/i18n';
import { accountRoles, accountRolesT, accountRegistrationStatusesT, socialStatusT, loanHistoryStatus, adminRolesT } from '../../../common/enums';
import { ResponsiveTable } from '../../../common/components/data-display';
import { formatDateTime } from '../../../common/utils/helpers';
import LoanHistoryContainer from '../../loan-management/containers/LoanHistoryContainer';

const Column = Table.Column;

const nameFunction = (nameFirst, item, index) => {
  return {
    children: <span>{`${item.nameFirst} ${item.nameLast}`}</span>,
  };
};

const personalFunction = (nameFirst, item, index) => {
  return {
    children: <span>{`${item.profileData.personalNumber ? item.profileData.personalNumber:""}/${item.profileData.idCardNumber ? item.profileData.idCardNumber:"" }`}</span>,
  };
};

const phoneemailFunction = (phone, item, index) => {
  return {
    children: <span>{item.profileData.phone} <br/> {item.profileData.email}</span>,
  };
};
const adressFunction = (adress, item, index) => {
  return {
    children: <span>{item.profileData.address ? item.profileData.address.street : ""}<br />{item.profileData.address ? item.profileData.address.zip : ""} {item.profileData.address ? item.profileData.address.city : ""}</span>,
  };
};
const incomeFunction = (adress, item, index) => {
  let status = item.profileData.employer ? item.profileData.employer : socialStatusT[item.profileData.socialStatus];
  return {
    children: <span>{status} <br />{item.profileData.income ? item.profileData.income.monthlyAvg : 0} €/{item.profileData.costs ? item.profileData.costs.monthlyAvg : 0} €</span>,
  };
};
const pozickyRender = (account) => {
  return {
    children: (
      <React.Fragment>
        <LoanHistoryContainer accountId={account.id} historyStatus={loanHistoryStatus.CAK} count={account.cakNum}></LoanHistoryContainer>
        <span>/</span>
        <LoanHistoryContainer accountId={account.id} historyStatus={loanHistoryStatus.AKT} count={account.schvNum}></LoanHistoryContainer>
        <span>/</span>
        <LoanHistoryContainer accountId={account.id} historyStatus={loanHistoryStatus.UHR} count={account.zatNum}></LoanHistoryContainer>
        <span>/</span>
        <LoanHistoryContainer accountId={account.id} historyStatus={loanHistoryStatus.ZAM} count={account.rejNum}></LoanHistoryContainer>
      </React.Fragment>
    ),
  };
};

const AccountsTable = ({ accounts, actions, loading, onChange, pagination, t }) => (
  <ResponsiveTable
    dataSource={accounts}
    loading={loading}
    onChange={onChange}
    pagination={pagination}
    rowKey={account => account.id}
    rowClassName={account => account.blacklist.length > 0 ? 'blacklist-row' : (account.nonpayer ? 'nonpayer-row' : '')}
  >
    <Column
      title={t('Meno')}
      dataIndex="nameFirst"
      key="nameFirst"
      render={(nameFirst, item, index) => nameFunction(nameFirst, item, index)}
    />

    <Column
      title={t('Telefón/E-mail')}
      dataIndex="email"
      key="email"
      render={(email, item, index) => phoneemailFunction(email, item, index)}
    />
    <Column
      title={t('Rodné číslo / Číslo OP')}
      dataIndex="personal"
      key="personal"
      render={(personal, item, index) => personalFunction(personal, item, index)}
    />
    <Column
      title={t('Ulica/PSČ/Mesto')}
      dataIndex="adress"
      key="adress"
      render={(adress, item, index) => adressFunction(adress, item, index)}
    />
    <Column
      title={t('Mesačný príjem/náklady')}
      dataIndex="income"
      key="income"
      render={(income, item, index) => incomeFunction(income, item, index)}
    />
    <Column
      dataIndex="registrationStatus"
      key="registrationStatus"
      render={status => accountRegistrationStatusesT[status]}
      title={t('Stav')}
    />
    <Column
      title={t('Pôžičky  ČAKÁ/AKT/UHR/ZAM')}
      dataIndex="rejNum"
      width="130px"
      key="rejNum"
      render={(_, account) => pozickyRender(account)} />
    <Column title={t('Rola')} dataIndex="role" key="role" render={role => accountRolesT[role]} />
    <Column title={t('Dátum vytvorenia')} dataIndex="createdAt" key="dateCreated" render={createdAt => formatDateTime(createdAt)} />


    <Column title={t('Akcie')} key="action" render={actions} />
  </ResponsiveTable>
);

AccountsTable.propTypes = {
  accounts: PropTypes.array.isRequired,
  actions: PropTypes.func,
  loading: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
  pagination: PropTypes.object.isRequired,
  t: PropTypes.func.isRequired,
};

AccountsTable.defaultProps = {
  actions: (text, account) => <Link to={`/cc/${account.id}`}>{t('Detail')}</Link>,
};

export default translate()(AccountsTable);



// WEBPACK FOOTER //
// ./src/features/call-centrum/components/AccountsTable.js